import Vue from 'vue'
import Vuex from 'vuex'
import clone from 'clone-deep'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    notes: []
  },

  mutations: {
    updateNotes(state, notes) {
      state.notes = notes
    },

    createNote(state, newNote) {
      state.notes.push(newNote)
    },

    updateNote(state, { id, data }) {
      const index = state.notes.findIndex(note => note.id == id)

      state.notes[index] = clone({
        ...state.notes[index],
        ...data
      })
    },

    deleteNote(state, id) {
      const index = state.notes.findIndex(note => note.id == id)

      state.notes.splice(index, 1)
    }
  },

  actions: {
    fetchNotes({ commit }) {
      const notes = JSON.parse(localStorage.getItem('notes')) || []

      commit('updateNotes', notes)
    },

    saveNotes({ getters }) {
      localStorage.setItem('notes', JSON.stringify(getters.allNotes))
    }
  },

  getters: {
    allNotes(state) {
      return state.notes
    },

    note: state => id => state.notes.find(note => note.id == id),

    notesCount(state) {
      return state.notes.length
    }
  }
})
